import * as XLSX from 'xlsx-js-style';
import moment from 'moment';

export const exportAllDataExcel = (
  bodyData,
  UserDefaultValues,
  { qtr, requestorUserId },
  logInUser,
  fileName
) => {
  const headerData = {
    prinDate: moment(new Date()).format('MM/DD/YYYY'),
    requestedBy: logInUser,
    reportName: 'Quarterly Claim Reconciliation',
    qtr,
    requestorUserId,
  };

  const worksheet = [];

  // ------------------------
  // HEADER
  // ------------------------
  //worksheet.push([]);

  // ------------------------
  // CONTENT (single table)
  // ------------------------
 

// ------------------------
// CONTENT (single table)
// ------------------------
const { rightGridData = {} } = bodyData;
const rebateKeys = Object.keys(rightGridData).sort();

worksheet.push([
  "Rebate Program Cd",
  "Quarter",
  "Claim Load Date",
  "Claim Count",
]);

let grandTotal = 0;

// Collect all rows first
let allRows = [];

rebateKeys.forEach((rebateKey) => {
  const rightList = rightGridData[rebateKey] || [];

  rightList.forEach((right) => {
    allRows.push({
      rebateKey,
      qtr: headerData.qtr,
      claimLoadDt: right?.claimLoadDt || "",
      recordCount: right?.recordCount || 0,
    });
    grandTotal += right?.recordCount || 0;
  });
});

// Sort globally by claimLoadDt ascending
allRows.sort((a, b) => {
  const dateA = new Date(a.claimLoadDt || 0);
  const dateB = new Date(b.claimLoadDt || 0);
  return dateA - dateB;
});

// Push sorted rows into worksheet
allRows.forEach((row) => {
  worksheet.push([
    row.rebateKey,
    row.qtr,
    row.claimLoadDt,
    row.recordCount.toLocaleString("en-US"),
  ]);
});

// Grand total row
worksheet.push([
  "",
  "",
  "Grand Total:",
  grandTotal.toLocaleString("en-US"),
]);


  // ------------------------
  // WORKBOOK
  // ------------------------
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(worksheet);
  XLSX.utils.book_append_sheet(wb, ws, fileName);

  const finalFilename = fileName ? `${fileName}.xlsx` : 'QuarterlyClaimReconciliation.xlsx';
  XLSX.writeFile(wb, finalFilename);
};
